<app-button-rectangle
  [disabled]="applyDisabled"
  [size]="'large'"
  [buttonTheme]="'primary'"
  [text]="T.common.apply | translate"
  (clicked)="onApply()"
></app-button-rectangle>
